import setting from './settings';

export default (() => {
  return {

    // Basic Auth
    'AUTH': setting.api.AUTH,

    // Auth
    signUp: `${setting.api.url}user/signup`,
    otp: `${setting.api.url}user/verify-otp`,
    resendOtp: `${setting.api.url}user/resend-otp`,
    createPwd: `${setting.api.url}user/create-password`,
    changePassword: `${setting.api.url}user/changePassword`,
    login: `${setting.api.url}user/mobile-login`,
    forgotPassword: `${setting.api.url}user/forgetPassword`,
    resetPassword: `${setting.api.url}user/resetPassword`,
    addUserDetails: `${setting.api.url}user/personal-info/add`,
    addBankDetails: `${setting.api.url}user/bankDetails`,
    addKycDetails: `${setting.api.url}user/kycDetails`,
    addWorkDetails: `${setting.api.url}user/workDetails`,
    companyList: `${setting.api.url}user/companyNameList`,

    // Uploads
    uploadNinSlip: `${setting.api.url}user/uploadFileToServerNinSlip`,
    uploadValidId: `${setting.api.url}user/uploadFileToServerValidId`,
    uploadUtility: `${setting.api.url}user/uploadFileToServerUtility`,

    // Partner
    getUserList: `${setting.api.url}user/getUserList`,

    // Profile/details
    getUserDetails: `${setting.api.url}user/profile`,

    // ============================
    // Salary Advance / Salary Top-Up
    // ============================

    // INITIATE (processing fee + payment date)
    // POST body:
    //  - Salary Advance: { amount, loanType: "salaryAdvance" }
    //  - Salary Top-Up : { amount, loanType: "salaryTopUp", duration }
    fetchRequestDetails: `${setting.api.url}request/fetch-request-details`,

    // SUBMIT (create request) — multipart/form-data
    //  - Salary Advance fields: requestedAmount, interestAmount, salaryDueDate, loanType="salaryAdvance", need
    //  - Salary Top-Up  fields: requestedAmount, interestAmount, salaryDueDate, loanType="salaryTopUp", duration, whyNeedMoney
    submitRequest: `${setting.api.url}request/submit`,

    // Request history & details
    withdrawRecent: `${setting.api.url}user/withdrawal/recent`,
    transactionList: `${setting.api.url}user/transactions`,
    requestDetail: `${setting.api.url}user/requestDetail`,

    // Home & verification
    checkProfileStatus: `${setting.api.url}user/status`,
    homeDashboard: `${setting.api.url}user/home`,
    getCompanyContractorSite: `${setting.api.url}user/getCompanyContractorSiteUpdated`,
    cancelRequest: `${setting.api.url}user/cancelRequest`,

    // Refer employer
    referEmployer: `${setting.api.url}user/referEmployer`,

    // ----------------------------
    // Legacy (avoid using; kept for fallback)
    // Old initiate endpoint (GET) – superseded by fetchRequestDetails (POST)
    requestAmount: `${setting.api.url}request/processingFeedetails`,
  }
})();
